'use client';

import React from 'react';
import { Chip, Tooltip } from '@heroui/react';
import { useTranslations } from '../../../../contexts/translation.context';
import { ResponsiveTooltip, Typography } from '../../../../components';
import { RevshareAccount } from '../types';
import { getStatusLabels, getStatusDotColor } from '../constants';
import { CalendarIcon } from '../../../../components/icons';

interface StatusCellProps {
  account: RevshareAccount;
}

const StatusCell: React.FC<StatusCellProps> = ({ account }) => {
  const { t } = useTranslations();
  const statusLabels = getStatusLabels(t);

  const status = account.status || 'active';
  const dotColor = getStatusDotColor(status);
  const label = statusLabels[status] || t('partner.partnerAccounts.statusUnknown');

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  const isModeration = status === 'moderation';

  const chipElement = (
    <Chip
      className="rounded-lg bg-gray-100 text-gray-900"
      classNames={{
        base: `h-6 px-2 py-1 gap-1 ${isModeration ? 'cursor-pointer' : ''}`,
      }}
      size="sm"
      startContent={<div className={`w-2 h-2 rounded-full ${dotColor}`}></div>}
    >
      <Typography variant="body3" className="text-gray-900">
        {label}
      </Typography>
    </Chip>
  );

  return (
    <div className="flex flex-col gap-2 py-2">
      {isModeration ? (
        <ResponsiveTooltip content={t('partner.partnerAccounts.moderationTooltip')} placement="top">
          {chipElement}
        </ResponsiveTooltip>
      ) : (
        chipElement
      )}
      <div className="flex items-center gap-1 text-sm text-auth-muted">
        <CalendarIcon className="w-3.5 h-3.5" />
        <span>{formatDate(account.added_at)}</span>
      </div>
    </div>
  );
};

export default StatusCell;
